<script>
import PasswordField from '@phoenix/mixins/components/form/fields/PasswordField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [PasswordField],

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <text-field v-model="value" :attrs="fieldAttrs" :should-validate="false" />
</template>
